(function() {
  'use strict';

  angular
    .module('blocks.easapi', []);
})();
